import Vue from 'vue';
import VueRouter from 'vue-router';
import { constantRoutes, asyncRoutes } from './_router';
import { stringifyQuery, parseQuery } from '@/util/query' //路径位置根据实际修改

Vue.use(VueRouter);

const router = new VueRouter({
  stringifyQuery, // 序列化query参数
  parseQuery, // 反序列化query参数
  mode: 'history',
  strict: process.env.NODE_ENV !== 'production',
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    if (from.meta.keepAlive) {
      from.meta.savedPosition = document.body.scrollTop;
    }
    return {
      x: 0,
      y: to.meta.savedPosition || 0,
    };
  },
  routes: [ ...constantRoutes, ...asyncRoutes]
});

function isMobileDevice() {
  if (typeof navigator === 'undefined') {
    return false;
  }
  const ua = navigator.userAgent || '';
  return /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i.test(ua);
}

router.beforeEach((to, from, next) => {
  const isMobile = isMobileDevice();

  // if (isMobile && to.path === '/login') {
  //   return next({
  //     path: '/mobile/login',
  //     query: to.query,
  //     hash: to.hash,
  //     replace: true
  //   });
  // }

  if (!isMobile && to.path === '/mobile/login') {
    return next({
      path: '/login',
      query: to.query,
      hash: to.hash,
      replace: true
    });
  }

  next();
});

export default router;
